import React from 'react';
import { History } from 'history';
import { Input, InputEmail, InputFile, InputPassword, InputSwitch, InputPicklist } from '../../components';
import BaseDelete from '../base/base-delete.component'; 
import Model from './user-model';  //editable..
import AppService from '../../services/app.service';

interface IProps { 
    history: History;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class UserDelete extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
    }

    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }

    render() {
        return (
            //editable..
            <BaseDelete history={this.props.history} 
                model={Model} onLoad={this.onLoad}>              
                
                <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} readOnly/>
                <Input name='name' label='User Name' value={this.state.datarow.name} readOnly />
                <InputEmail name='useremail' label='Email' value={this.state.datarow.useremail} readOnly />
                <InputPassword name='password' label='Password' value={this.state.datarow.password} readOnly />
                {AppService.isAppFullVersion() &&
                <InputPicklist name='owner' label='Owner' value={this.state.datarow.owner} readOnly caption={this.state.datarow.ownerCaption} />   
                }
                <InputFile name='imageUrl' label='Image' value={this.state.datarow.imageUrl} type='image' readOnly/>
            </BaseDelete>
        );
    }
}